import { http } from '../../../utils/http';
import { HealthListParam, ContentParam, SaveParam } from '../store/types';
import qs from 'qs';

const prefix = '/vote/2019poject/2019pharmacy/controller.php?enews=';

// base-info
export const getBaseinfo = async () => {
  const res = await http.get(prefix + 'base-info');

  return res;
};

// 报名页面提交报名接口
export function save(data: any) {
  const qsData = qs.stringify(data);
  return http.post(prefix + 'save', qsData);
}

// 投票列表页
export const getList = async ({ type, page }: HealthListParam) => {
  const res = await http.get(
    prefix + 'vote-list&type=' + type + '&page=' + page,
  );

  return res;
};

// 搜索列表页
export const getListSearch = async ({
  type,
  page,
  search,
}: HealthListParam) => {
  const res = await http.get(
    prefix + 'vote-list&type=' + type + '&page=' + page + '&search=' + search,
  );

  return res;
};

// 详情页
export const getContent = async ({ type, id }: ContentParam) => {
  const res = await http.get(prefix + 'detail&type=' + type + '&id=' + id);

  return res;
};
